var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cp-page-belt"},[_c('div',{staticClass:"join-us",class:_vm.info[_vm.beltType].bgClass},[_c('p',[_vm._v(_vm._s(_vm.info[_vm.beltType].title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }